<template>
    <modal
        id="work-orders-job-types-modal"
        ok-title="Save"
        :title="modalTitle"
        :okDisabled="!meta.valid"
        @hide="onModalHide"
        @cancel="onModalHide"
        @ok="onJobTypeSave"
        @shown="setData"
    >
        <div>
            <b-row>
                <b-col md="2">
                    <label>Title:</label>
                </b-col>
                <b-col>
                    <form-input
                        trim
                        id="work-order-job-type-title"
                        type="text"
                        v-model="title"
                        :error="errors.title"
                    ></form-input>
                </b-col>
            </b-row>
        </div>
    </modal>
</template>

<script setup>
    import { computed } from 'vue';
    import Modal from '../../generic/modal/modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import { useForm } from 'vee-validate';

    const props = defineProps({
        modalType: {
            type: String,
            default: 'create',
        },
        jobTypeItem: {
            type: Object,
            default: () => {},
        },
    });

    const { setValues, meta, errors, defineField, values } = useForm({
        validationSchema: {
            title: 'required',
        },
        initialValues: {
            title: props.jobTypeItem.title || '',
        },
    });

    const [title] = defineField('title');

    const emit = defineEmits(['hide', 'ok', 'cancel']);

    const onJobTypeSave = () => {
        emit('ok', { ...values });
    };

    const modalTitle = computed(() => {
        return props.modalType === 'create' ? 'Add Job Type' : 'Edit Job Type';
    });

    const onModalHide = () => {
        emit('hide');
    };

    const setData = () => {
        setValues({
            ...props.jobTypeItem,
        });
    };
</script>
